module.exports = __webpack_public_path__ + "static/img/about-1-Overview-img-3.6ff5584.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-1-Overview-img-3.jpg
// module id = R+R6
// module chunks = 0